export default "__VITE_ASSET__$lpuzuod__"